export class ProductAuthRequest {
  qrData: string;
  compNm: string;
  compId: any;
  mobNo: string;
  usrname: string;
  askForDetailsFilled: boolean;
  askForScratchFilled: boolean;
  email: string;
  verifiedBy: string;
  verificationMode: string;
  verificationType: number;
  deviceDetails: string;
  ipAdrs: string;
  usrlatitude: number;
  usrlongitude: number;
  usrAdrs: string;
  usrCity: string;
  usrState: string;
  usrCntry: string;
  usrZip: string;
  usrFeedback: string;
  scratchCd: string;
  purchasedFrm: string;
  mobOprator: string;
  askCompId: any;
}

export class ProductAuthResponse {
  responseCode: string;
  responseMessage: string;
  compId: any;
  data: ProdAuthData;
}

export class ProdAuthData {
  compDispNm: string;
  compId: string;
  compNm: string;
  productId: string;
  productNm: string;
  compLogo: string;
  productImg: string[];
  prodSpecification: ProdSpecification[];
  productRating: string;
  totalRating: string;
  shareURL: string;
  shareMsg: string;
  promotionlMsg: string;
  loyaltyMsg: string;
  isShare: string;
  isLoyalty: string;
  isFeedback: string;
  isRating: string;
  isPromotionalMsg: string;
  genuineAudio: string;
  similarProducts: SimilarProducts[];
  socialLinks: SocialLinks[];
  verificationId: string;
  isShowLoyalty: string;
  isAgro: string;
  cautionaryImage: string;
  isTransfer: string;
  isTransferPending: string;
  seqNo: string;
  points: string;
  prefix: string;
  easebuzz_Bank: boolean;
  easebuzz_Paytm: boolean;
  easebuzz_UPI: boolean;
  scanCount: string;
  lastScannedOn: string;
}

export class CustomFieldDetails {
  fieldName: string;
  displayName: string;
  isHide: boolean;
  isValidate: boolean;
}

export class CustomPage {
  pageName: string;
  displayPageName: string;
  fieldDetails: CustomFieldDetails[];
}

export class CustomFieldResponse {
  responseCode: string;
  responseMessage: string;
  details: CustomPage[];
}

export class ProdSpecification {
  key: string;
  value: string;
}
export class SimilarProducts {
  productImg: string[];
  prodSpecification: ProdSpecification[];
  productRating: string;
  totalRating: string;
  productNm: string;
  isRating: string;
}
export class SocialLinks {
  key: string;
  value: string;
}

export class ProductRatingResponse {
  responseCode: string;
  responseMessage: string;
  data: ProductRating;
}
export class ProductRating {
  ratingId: number;
  compId: string;
  productId: string;
  proRating: string;
  totalRatingCount: string;
  updatedBy: string;
  updatedDt: string;
  verificationId: string;
}
export class GetUserVerification {
  productNm: string;
  compNm: string;
  usrState: string;
  productImg: [];
  usrCity: string;
  scanStatus: string;
}
export class GetUserVerificationResponse {
  responseCode: string;
  responseMessage: string;
  data: GetUserVerification[];
}

export class TamilRiceAuth extends ProductAuthRequest {
  isDetailsFilled: boolean;
  product: number;
  netWeight: number;
  grossWeight: number;
  location: string;
  vehicleNo: string;
  isFilled: boolean;
  dispatchDate: Date;
  isReceived: boolean;
  receivedDate: Date;
  estJourneyTime: number;
  actJourneyTime: string;
  isReceiving: boolean;
}

export class TamilRiceAuthResponse {
  responseCode: string;
  responseMessage: string;
  data: TamilRiceAuth;
}

export class PatanjaliData {
  responseCode: string;
  name: string;
  id: string;
  seqNo: string;
  qrData: string;
  key: string;
  productName: string;
  size: string;
  image: string;
  batchNo: string;
  mrp: string;
  mfg: string;
  exp: string;
}
